import React from 'react';
import { GenericListPage } from '../../components/generic';
import { CustomField, useCustomFields } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

const List: React.FC = () => {
  const { colors } = useTheme();
  const useCustomFieldsList = () => {
    const { data, isLoading, mutate } = useCustomFields();
    return {
      data,
      isLoading,
      mutate,
    };
  };

  return (
    <div className="flex flex-col h-full min-h-0">
      {/* GenericListPage */}
      <div className="flex-1 min-h-0 overflow-hidden">
        <GenericListPage<CustomField>
          useData={useCustomFieldsList}
          config={{
            ...moduleConfig,
            getColumns,
            getToolbarIcon,
            getTableActions,
          }}
        />
      </div>
    </div>
  );
};

export default List;
